import { render, staticRenderFns } from "./ReqStats.vue?vue&type=template&id=493e531d&scoped=true"
import script from "./ReqStats.vue?vue&type=script&lang=js"
export * from "./ReqStats.vue?vue&type=script&lang=js"
import style0 from "./ReqStats.vue?vue&type=style&index=0&id=493e531d&prod&lang=css"
import style1 from "./ReqStats.vue?vue&type=style&index=1&id=493e531d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e531d",
  null
  
)

export default component.exports